import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { TREND_DETAIL_AGE_GENDER_SET } from '../../../../config/TrendDetailAgeGenderSet';

const resultToVolumePieData = (data) => {
  let pieData = [];

  data.query.forEach((item, index) => {
    const pcKey = `pc${index}`;
    const moKey = `mo${index}`;
    const allKey = `all${index}`;

    let queryPcValue = 0;
    let queryMoValue = 0;
    let queryAllValue = 0;

    let date = '';
    let end_date = '';

    data.data.forEach((dataItem, index) => {
      queryPcValue = queryPcValue + dataItem[pcKey];
      queryMoValue = queryMoValue + dataItem[moKey];
      queryAllValue = queryAllValue + dataItem[allKey];

      if (index == 0) date = dataItem.date;
      if (index == data.data.length - 1) {
        if (dataItem.hasOwnProperty('end_date')) {
          end_date = dataItem.end_date;
        }
        else end_date = dataItem.date;
      }
    })

    pieData.push({
      "query": `${item} (all)`,
      "value": queryAllValue,
      "date": date,
      "end_date": end_date
    })
  })

  return pieData;
}

const resultToDetailPieData = (data) => {
  let pieData = [];

  data.query.forEach((queryItem, queryIndex) => {
    data.genderage.forEach((gaItem, gaIndex) => {
      const queryKey = `all${queryIndex}-${gaItem}`;

      let queryAllValue = 0;
      let date = '';
      let end_date = '';

      data.data.forEach((dataItem, index) => {
        queryAllValue = queryAllValue + dataItem[queryKey];

        if (index == 0) date = dataItem.date;
        if (index == data.data.length - 1) {
          if (dataItem.hasOwnProperty('end_date')) {
            end_date = dataItem.end_date;
          }
          else end_date = dataItem.date;
        }
      })
      pieData.push({
        "query": `${queryItem} (${TREND_DETAIL_AGE_GENDER_SET[gaItem]})`,
        "value": queryAllValue,
        "date": date,
        "end_date": end_date
      })
    })
  })

  return pieData;
}

class PieForTrend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickedData: null,
      showModal: false
    }
  }

  componentDidMount() {
    const data = this.props.data;
    const excelExportFunc = this.props.excelExportFunc;
    const reportType = this.props.reportType;
    const reportName = this.props.reportName;
    const type = this.props.type;

    let chart = null;

    switch (reportType) {
      case "volume": {
        this.createVolumePieForTrend(type, chart, reportName, data, excelExportFunc);
        break;
      }
      case "detail": {
        this.createDetailPieForTrend(type, chart, reportName, data, excelExportFunc);
        break;
      }
      default:
        break;
    }
  }

  componentWillUnmount() {
    if (this.chart) this.chart.dispose();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.data != null) && (prevProps.data !== this.props.data)) {
      if (this.chart) {
        this.chart.dispose();
      }
      const data = this.props.data;
      console.log(data)
      const excelExportFunc = this.props.excelExportFunc;
      const reportType = this.props.reportType;
      const reportName = this.props.reportName;
      const type = this.props.type;

      let chart = null;

      switch (reportType) {
        case "volume": {
          this.createVolumePieForTrend(type, chart, reportName, data, excelExportFunc);
          break;
        }
        case "detail": {
          this.createDetailPieForTrend(type, chart, reportName, data, excelExportFunc);
          break;
        }
        default:
          break;
      }
    }
  }

  createVolumePieForTrend = (type, chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.pieChart, am4charts.PieChart);
    am4core.useTheme(am4themes_animated);
    console.log(dataSet)
    chart.data = resultToVolumePieData(dataSet);
    chart.padding(0, 0, 0, 0);

    let name = dataSet.query.join(' & ');
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "query";
    series.slices.template.propertyFields.fill = "color";
    // series.slices.template.tooltipText = `${name} ({query}): [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    // series.labels.template.text = `${name} ({query}): [bold]{value}[/]`
    series.slices.template.tooltipText = `{query}: [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    series.labels.template.text = `{query}: [bold]{value}[/]`

    if (type == 'snapshot') {
      series.labels.template.disabled = true;
    }


    // series.slices.template.events.on("hit", (ev) => {
    //   this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    // })
    let hs = series.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    let as = series.slices.template.states.getKey("active");
    as.properties.shiftRadius = 0;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("pie-export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    chart.legend = new am4charts.Legend();

    this.chart = chart;
  }

  createDetailPieForTrend = (type, chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.pieChart, am4charts.PieChart);
    am4core.useTheme(am4themes_animated);
    chart.data = resultToDetailPieData(dataSet);
    chart.padding(0, 0, 0, 0);

    let name = dataSet.query.join(' & ');
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "query";
    series.slices.template.propertyFields.fill = "color";
    // series.slices.template.tooltipText = `${name} ({query}): [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    // series.labels.template.text = `${name} ({query}): [bold]{value}[/]`
    series.slices.template.tooltipText = `{query}: [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    series.labels.template.text = `{query}: [bold]{value}[/]`

    if (type == 'snapshot') {
      series.labels.template.disabled = true;
    }


    // series.slices.template.events.on("hit", (ev) => {
    //   this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    // })
    let hs = series.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    let as = series.slices.template.states.getKey("active");
    as.properties.shiftRadius = 0;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("pie-export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    chart.legend = new am4charts.Legend();

    this.chart = chart;
  }

  render() {
    return (
      <div>
        <div id="pie-export-container" style={{ position: "relative", minHeight: "30px" }} />
        <div id="pie" ref={ref => (this.pieChart = ref)} style={{ width: this.props.width, height: this.props.height }}></div>
      </div>
    )
  }
}

export default PieForTrend;
